const UPDATE_MODES = {
  OVERRIDE: 'override',
  MERGE: 'merge',
};

export default UPDATE_MODES;

export const DEFAULT_UPDATE_MODE = UPDATE_MODES.MERGE;
